<mat-form-field  appearance="fill" *ngIf="(!isRolePopup || isCompanyPopup) && !isSharedAccessRolePopup && !isReviewerPopup" style="position: relative;" >
    <input matInput
           #stateInput (keyup)="0"
           placeholder={{placeholder}}
           aria-label="State"
           [matAutocomplete]="auto" 
           (input)="search($event.target.value,false)"
           [formControl]="stateCtrl"
           id="stateCtrlid"
           (click)="onclickContact($event.target.value)">
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option  (onSelectionChange)="stateInput.value !=undefined && selected(state,false)" 
       *ngFor="let state of objectList" [value]="state.name">
        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
            <div class="userpic">
                <img *ngIf="state.imageUrl!=''" src="{{state.imageUrl}}" alt="">
                <span class="username" *ngIf="state.imageUrl==''" class="username">
                    {{state.shortName}}
                  </span>
            </div>
            <div class="info">
              <p> {{ state.name }}</p>
              <p class="email">{{ state.email }}</p>
            </div> 
        </span>
      </mat-option>
    </mat-autocomplete>
    <!-- <button color="primary" mat-icon-button style="position: absolute; right: 0; top: -15px;" ><mat-icon>add</mat-icon></button> -->
  </mat-form-field>


  <mat-form-field  appearance="fill" *ngIf="isReviewerPopup==true">
    <input matInput
          #stateInput (keyup)="0"
           placeholder="Search User"
           aria-label="State"
           [matAutocomplete]="auto" 
           (input)="search($event.target.value,true)"
           [formControl]="stateCtrl"
           id="stateCtrlid"
           [(ngModel)]="roleInputCurrentvalue"
          >
     <mat-autocomplete #auto="matAutocomplete">
      <mat-option  (onSelectionChange)="stateInput.value !=undefined && selected(user,true)" 
       *ngFor="let user of objectList" [value]="user.name">
        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">            
            <div class="info">
              <p> {{ user.firstName }} {{ user.lastName }}</p>
              <p class="email">{{ user.email }}</p>
            </div> 
        </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field  appearance="fill" *ngIf="isRolePopup">
    <input matInput
            #stateInput (keyup)="0"
           placeholder="Search Relation"
           aria-label="State"
           [matAutocomplete]="auto" 
           (input)="search($event.target.value,true)"
           [formControl]="stateCtrl"
           id="stateCtrlid"
           [(ngModel)]="roleInputCurrentvalue"
          >
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option  (onSelectionChange)="stateInput.value !=undefined && selected(obj,true)" 
       *ngFor="let obj of objectList" [value]="obj.transactionalRoleName">
        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
          
            <div class="info">
              <p> {{ obj.transactionalRoleName }}</p>
            </div> 
        </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field  appearance="fill" *ngIf="isSharedAccessRolePopup">
    <input matInput
           #stateInput (keyup)="0"
           placeholder="Search Role"
           aria-label="State"
           [matAutocomplete]="auto" 
           (input)="search($event.target.value,true)"
           [formControl]="stateCtrl"
           id="stateCtrlid"
           [(ngModel)]="roleInputCurrentvalue"
           >
    <mat-autocomplete #auto="matAutocomplete">
      <mat-option (click)="selected(obj,true)" (onSelectionChange)="stateInput.value !=undefined && selected(obj,true)" 
         *ngFor="let obj of objectList" [value]="obj.roleName">
        <span class="userlist" fxLayout="row" fxLayoutAlign="flex-start center">
          
            <div class="info">
              <p> {{ obj.roleName }}</p>
            </div> 
        </span>
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>